import { Feather } from "@expo/vector-icons";
import { Button } from "./all";

export default () => {
  return (
    <Button
      type={"primary"}
      label="Back to Login"
      icon={<Feather name="login" size={14} color={"white"} />}
      onPress={() => {
        this.props.onPress();
      }}
    />
  );
};
